import React, { useState, useMemo } from 'react';
import { usePopper } from 'react-popper';
import { useNavigate } from 'react-router-dom';
import ListMenu from '../../../../../../../components/ListMenu';
import { useStore } from '../../../../../../../store';
import {
  PENDING_BILLS_MENU_ACTIONS,
  PAID_BILLS_MENU_ACTIONS,
  AVAILABLE_BILL_MODALS,
  AWAITING_DETAILS_BILLS_MENU_ACTIONS,
} from '../consts';
import { BILLS_STATUSES } from '../../../../../consts';
import { BILL_ACTIONS } from '../../../consts/actions';
import { VIEWS_MAP } from '../../../../../../../router/constants';

const BillActionsMenu = () => {
  const navigate = useNavigate();
  const selectedBill = useStore(state => state.selectedBill);
  const billActionsReferenceElement = useStore(state => state.billActionsReferenceElement);
  const setActiveBillModal = useStore(state => state.setActiveBillModal);
  const setShowBillDetailsModal = useStore(state => state.setShowBillDetailsModal);
  const [popperElement, setPopperElement] = useState<any>();
  const { styles, attributes } = usePopper(billActionsReferenceElement, popperElement, { placement: 'left-start' });
  const menuItems = useMemo(() => {
    if (selectedBill?.calculatedStatus === BILLS_STATUSES.PENDING) return PENDING_BILLS_MENU_ACTIONS;
    if (selectedBill?.calculatedStatus === BILLS_STATUSES.AWAITING_DETAILS) return AWAITING_DETAILS_BILLS_MENU_ACTIONS;
    return PAID_BILLS_MENU_ACTIONS;
  }, [selectedBill?.calculatedStatus]);

  const handleActionOnClick = (name: string) => {
    if (name === BILL_ACTIONS.MARK_AS_PAID) setActiveBillModal(AVAILABLE_BILL_MODALS.MARK_AS_PAID);
    if (name === BILL_ACTIONS.PREVIEW) {
      setActiveBillModal(AVAILABLE_BILL_MODALS.NONE);
      setShowBillDetailsModal(true);
    }
    if (name === BILL_ACTIONS.DUPLICATE) {
      setActiveBillModal(AVAILABLE_BILL_MODALS.NONE);
      navigate(`/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.CREATE_BILL.BASE}`, { state: { billId: selectedBill?.billId, billStatus: selectedBill?.calculatedStatus } });
    }
    if (name === BILL_ACTIONS.CANCEL) setActiveBillModal(AVAILABLE_BILL_MODALS.MARK_AS_CANCELED);
    if (name === BILL_ACTIONS.PAY_NOW) {
      navigate(`/${VIEWS_MAP.BILLS.BASE}/${VIEWS_MAP.BILLS.PAY_BILL.BASE}/${selectedBill?.billId}`);
    }
  };

  return (
    <div
      className='absolute z-20'
      ref={setPopperElement}
      style={styles.popper}
      {...attributes.popper}
    >
      <ListMenu testId='BillsHub__BillActionsSubMenu' menuItems={menuItems} onMenuItemClick={handleActionOnClick} className='shadow-popOver w-[280px]' />
    </div>
  );
};

export default BillActionsMenu;
